module.exports = __webpack_public_path__ + "static/IMG_5407-6be5c056edf14426b4bd8db1a024498a.jpg";